<template>
    <div class="login_page" v-loading="loading">
    </div>
</template>

<script>
    import {Index} from "../api/apiLogin";

    export default {
        name: 'login',
        data() {
            return {
                loading: true
            };
        },
        computed: {},
        watch: {},
        created() {
            this.Index();
        },
        mounted() {
        },
        methods: {
            // 跳转认证中心
            async Index() {
                try {
                    let data = await Index();
                    if (data.error_code === '0') {
                        if (this.$route.query.accessToken) {
                            window.location.href = data.data + '&accessToken=' + this.$route.query.accessToken + '&language=' + this.$route.query.language + '&company=' + this.$route.query.company;
                        } else {
                            window.location.href = data.data;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        }
    };
</script>

<style lang="less" scoped>

</style>
